export default __webpack_public_path__ + "static/media/SetPasswordPhn.c76c0706.svg";